import qs from 'qs';
import { axiosClient } from '@/libs/axios-client';

/**
 * Retrieves all enums with filters applied.
 * @returns {Promise<Object[]>} A promise that resolves with an array of enum objects.
 * @throws Will throw an error if the request fails.
 */
export const retrieveAllEnums = async (params) => {
  try {
    const response = await axiosClient.get('/assets/enums', {
      params,
      paramsSerializer: (params) => {
        if (params.filter) {
          params.filter = JSON.stringify(params.filter);
        }
        return qs.stringify(params, { encode: false, arrayFormat: 'brackets' });
      },
    });
    return response.data;
  } catch (error) {
    console.error('Failed to retrieve enums:', error);
    throw error;
  }
};

const EnumsService = {
  retrieveAllEnums,
};

export default EnumsService;
